const s = [
  {
    name: "Russia",
    code: "+7",
    iso: "RU",
    flag: "https://forma.today/icons/countries/ru.svg",
    mask: "(###)###-##-##"
  },
  {
    name: "Kazakhstan",
    code: "+77",
    iso: "KZ",
    flag: "https://forma.today/icons/countries/kz.svg",
    mask: "(###)###-##-##"
  },
  {
    name: "Georgia",
    code: "+995",
    iso: "GE",
    flag: "https://forma.today/icons/countries/ge.svg",
    mask: "(###)###-###"
  },
  {
    name: "Armenia",
    code: "+374",
    iso: "AM",
    flag: "https://forma.today/icons/countries/am.svg",
    mask: "##-###-###"
  },
  {
    name: "Turkey",
    code: "+90",
    iso: "TR",
    flag: "https://forma.today/icons/countries/tr.svg",
    mask: "(###)###-####"
  },
  {
    name: "Azerbaijan",
    code: "+994",
    iso: "AZ",
    flag: "https://forma.today/icons/countries/az.svg",
    mask: "##-###-##-##"
  },
  {
    name: "Kyrgyzstan",
    code: "+996",
    iso: "KG",
    flag: "https://forma.today/icons/countries/kg.svg",
    mask: "(###)###-###"
  },
  {
    name: "United States",
    code: "+1",
    iso: "US",
    flag: "https://forma.today/icons/countries/us.svg",
    mask: "(###)###-####"
  },
  {
    name: "Austria",
    code: "+43",
    iso: "AT",
    flag: "https://forma.today/icons/countries/at.svg",
    mask: "(###)###-####"
  },
  {
    name: "Belgium",
    code: "+32",
    iso: "BE",
    flag: "https://forma.today/icons/countries/be.svg",
    mask: "(###)###-###"
  },
  {
    name: "Bulgaria",
    code: "+359",
    iso: "BG",
    flag: "https://forma.today/icons/countries/bg.svg",
    mask: "(###)###-###"
  },
  {
    name: "United Kingdom",
    code: "+44",
    iso: "GB",
    flag: "https://forma.today/icons/countries/gb.svg",
    mask: "##-####-####"
  },
  {
    name: "Hungary",
    code: "+36",
    iso: "HU",
    flag: "https://forma.today/icons/countries/hu.svg",
    mask: "(###)###-###"
  },
  {
    name: "Germany",
    code: "+49",
    iso: "DE",
    flag: "https://forma.today/icons/countries/de.svg",
    mask: "(####)###-####"
  },
  {
    name: "Greece",
    code: "+30",
    iso: "GR",
    flag: "https://forma.today/icons/countries/gr.svg",
    mask: "(###)###-####"
  },
  {
    name: "Ireland",
    code: "+353",
    iso: "IE",
    flag: "https://forma.today/icons/countries/ie.svg",
    mask: "(###)###-###"
  },
  {
    name: "Spain",
    code: "+34",
    iso: "ES",
    flag: "https://forma.today/icons/countries/es.svg",
    mask: "(###)###-###"
  },
  {
    name: "Italy",
    code: "+39",
    iso: "IT",
    flag: "https://forma.today/icons/countries/it.svg",
    mask: "(###)####-###"
  },
  {
    name: "Cyprus",
    code: "+357",
    iso: "CY",
    flag: "https://forma.today/icons/countries/cy.svg",
    mask: "##-###-###"
  },
  {
    name: "Latvia",
    code: "+371",
    iso: "LV",
    flag: "https://forma.today/icons/countries/lv.svg",
    mask: "##-###-###"
  },
  {
    name: "Malta",
    code: "+356",
    iso: "MT",
    flag: "https://forma.today/icons/countries/mt.svg",
    mask: "####-####"
  },
  {
    name: "Netherlands",
    code: "+31",
    iso: "NL",
    flag: "https://forma.today/icons/countries/nl.svg",
    mask: "##-###-####"
  },
  {
    name: "Poland",
    code: "+48",
    iso: "PL",
    flag: "https://forma.today/icons/countries/pl.svg",
    mask: "(###)###-###"
  },
  {
    name: "Romania",
    code: "+40",
    iso: "RO",
    flag: "https://forma.today/icons/countries/ro.svg",
    mask: "##-###-####"
  },
  {
    name: "Slovakia",
    code: "+421",
    iso: "SK",
    flag: "https://forma.today/icons/countries/sk.svg",
    mask: "(###)###-###"
  },
  {
    name: "Slovenia",
    code: "+386",
    iso: "SI",
    flag: "https://forma.today/icons/countries/si.svg",
    mask: "##-###-###"
  },
  {
    name: "Finland",
    code: "+358",
    iso: "FI",
    flag: "https://forma.today/icons/countries/fi.svg",
    mask: "(###)###-##-##"
  },
  {
    name: "France",
    code: "+33",
    iso: "FR",
    flag: "https://forma.today/icons/countries/fr.svg",
    mask: "(###)###-###"
  },
  {
    name: "Croatia",
    code: "+385",
    iso: "HR",
    flag: "https://forma.today/icons/countries/hr.svg",
    mask: "##-###-###"
  },
  {
    name: "Montenegro",
    code: "+382",
    iso: "ME",
    flag: "https://forma.today/icons/countries/me.svg",
    mask: "##-###-###"
  },
  {
    name: "Czech Republic",
    code: "+420",
    iso: "CZ",
    flag: "https://forma.today/icons/countries/cz.svg",
    mask: "(###)###-###"
  },
  {
    name: "Estonia",
    code: "+372",
    iso: "EE",
    flag: "https://forma.today/icons/countries/ee.svg",
    mask: "####-####"
  },
  {
    name: "Sweden",
    code: "+46",
    iso: "SE",
    flag: "https://forma.today/icons/countries/se.svg",
    mask: "##-###-####"
  }
];
export {
  s as default
};
